import type { Company, CompanyPost } from '@/types';
import { simulate } from '@/services/api/client';
import { companyService } from '@/services/company/companyService';

/**
 * Company profile read/update (basic info, addresses, SIC, brand voice) +
 * company feed posts. Profile fields persist via companyService.update;
 * posts are mock (would come from the `feed_posts` collection filtered by
 * companyId).
 */
function seedPosts(companyId: string): CompanyPost[] {
  const base = Date.now();
  return [
    { id: `${companyId}-p1`, companyId, authorName: 'Alex Morgan', content: 'Excited to announce our new AI-powered onboarding flow — live now! 🎉', likes: 42, comments: 6, createdAt: new Date(base - 6 * 3600_000).toISOString() },
    { id: `${companyId}-p2`, companyId, authorName: 'Priya Patel', content: 'We\'re hiring across engineering and design. Come build with us.', likes: 18, comments: 3, createdAt: new Date(base - 2 * 86400_000).toISOString() },
    { id: `${companyId}-p3`, companyId, authorName: 'Company', content: 'Q2 was our best quarter yet — thank you to our customers and team.', likes: 67, comments: 12, createdAt: new Date(base - 5 * 86400_000).toISOString() },
  ];
}

export const companyProfileService = {
  getProfile: (companyId: string) => companyService.getById(companyId),

  /** Update top-level profile fields (name, description, addresses, SIC, …). */
  updateProfile: (companyId: string, patch: Partial<Company>) =>
    companyService.update({ ...patch, id: companyId }),

  /** Company feed posts (mock; filter `feed_posts` by companyId later). */
  getPosts: (companyId: string, limit = 5): Promise<CompanyPost[]> =>
    simulate(seedPosts(companyId).slice(0, limit)),
};
